import { createTrawlerRecord } from "../domains/esg_taxonmy_trawler_model";

const CHAR_LIMIT = 250; // Match SQL staging limit
const IGNORE_VALS = ['nan', 'none', 'nat', '']; // Standard Python nulls

/**
 * 🕵️ TAXONOMY TRAWLER CONTROLLER
 * Executes Pass 1: Physical profiling of Excel Linkbases
 * Location: src/registered/site-admin/components/Workflow-esg/controllers/TaxonomyTrawlerController.js
 */
export const runTaxonomyTrawl = (worksheets) => {
  const columnMap = {}; 
  if (!worksheets || !Array.isArray(worksheets)) return [];

  worksheets.forEach(ws => {
    // 🎯 FIX: Prioritize 'data' (full rows) from the new streamlined XlsxController
    const rows = ws.data || ws.sampleRows || [];
    const headers = ws.headers || [];

    rows.forEach((row) => {
      headers.forEach((colName, colIndex) => {
        // Ensure we are reading the cell string safely
        let rawVal = String(row[colIndex] ?? "").trim();

        if (rawVal && !IGNORE_VALS.includes(rawVal.toLowerCase())) {
          // Initialize record if this is a new column discovery
          if (!columnMap[colName]) {
            columnMap[colName] = createTrawlerRecord(colName);
          }

          const record = columnMap[colName];
          
          // Truncate the value for the unique set to simulate SQL storage constraints
          const valToStore = rawVal.substring(0, CHAR_LIMIT); 
          const valLen = rawVal.length;

          // Update Trawler Metrics
          record.UniqueValues.add(valToStore);
          record.TotalOccurrences += 1;
          record.MinLength = Math.min(record.MinLength, valLen);
          record.MaxLength = Math.max(record.MaxLength, valLen);
        }
      });
    });
  });

  // Convert Set sizes to integers and clean up Infinity for the RTF and UI views
  return Object.values(columnMap).map(record => ({
    ...record,
    UniqueValueCount: record.UniqueValues.size,
    MinLength: record.MinLength === Infinity ? 0 : record.MinLength
  }));
};